import React from 'react';

import { Icon } from '@chakra-ui/react';

export const StopSignIcon = props => (
  <Icon viewBox="0 0 2017 2016" color="inherit" h="full" w="full" {...props}>
    <g transform="translate(-1191 -229)">
      <g>
        <path
          d="M2554.51 2243 1845.49 2243C1804.46 2243.11 1765.08 2226.8 1736.15 2197.68L1240.29 1701.58C1211.2 1672.63 1194.89 1633.24 1195 1592.19L1195 882.814C1194.89 841.76 1211.2 802.369 1240.29 773.423L1736.15 277.318C1765.08 248.205 1804.46 231.886 1845.49 232.001L2554.51 232.001C2595.54 231.886 2634.92 248.205 2663.85 277.318L3159.71 773.423C3188.8 802.369 3205.11 841.76 3205 882.814L3205 1592.19C3205.11 1633.24 3188.8 1672.63 3159.71 1701.58L2663.85 2197.68C2634.92 2226.8 2595.54 2243.11 2554.51 2243Z"
          fill="#C00000"
          fill-rule="evenodd"
          fill-opacity="1"
        />
      </g>
    </g>
  </Icon>
);
